import { useState } from "react";
import { z } from "zod";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

const schema = z.object({
  email: z.string().trim().email("Enter a valid email").max(255),
});

export function NewsletterBanner() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const parsed = schema.safeParse({ email });
    if (!parsed.success) {
      toast.error(parsed.error.issues[0].message);
      return;
    }
    setLoading(true);
    const { error } = await supabase
      .from("newsletter_subscribers")
      .insert({ email: parsed.data.email, source: "footer_banner" });
    setLoading(false);
    if (error && !error.message.toLowerCase().includes("duplicate")) {
      toast.error("Something went wrong. Try again.");
      return;
    }
    setDone(true);
    setEmail("");
    toast.success("Welcome to the House.");
  }

  return (
    <section className="border-t border-hairline bg-secondary/40">
      <div className="mx-auto max-w-4xl px-6 py-20 text-center lg:px-12">
        <p className="text-xs uppercase tracking-luxe text-muted-foreground">
          The HOWDEN Letter
        </p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight md:text-4xl">
          New cuts, private viewings, quiet stories.
        </h2>

        {done ? (
          <p className="mt-10 text-sm uppercase tracking-luxe text-foreground">
            You're in. Watch your inbox.
          </p>
        ) : (
          <form
            onSubmit={onSubmit}
            className="mx-auto mt-10 flex w-full max-w-md flex-col items-stretch gap-3 sm:flex-row"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 border border-hairline bg-background px-4 py-3 text-sm tracking-wide outline-none transition-colors focus:border-foreground"
            />
            <button
              type="submit"
              disabled={loading}
              className="border border-foreground bg-foreground px-6 py-3 text-xs uppercase tracking-luxe text-background transition-opacity hover:opacity-80 disabled:opacity-50"
            >
              {loading ? "Subscribing…" : "Subscribe"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
